import create from 'zustand';

type ModalStore = {
  open: (() => void) | null,
  close: (() => void) | null,

  setOpen: (fn: (() => void) | null) => void,
  setClose: (fn: (() => void) | null) => void
}

const useModalStore = create<ModalStore>(set => ({
  open: null,
  close: null,

  setOpen: fn => set(() => ({ open: fn })),
  setClose: fn => set(() => ({ close: fn }))
}));

export default useModalStore;